import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { ResponsibilityPicker } from './MyProfile';

const STEPS = ['Personal Info', 'University & Internship', 'Responsibilities', 'Preview & Submit'];

export default function GuestSubmit() {
  const nav = useNavigate();
  const [step, setStep]     = useState(0);
  const [templates, setTemplates] = useState([]);
  const [previewing, setPreviewing] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone]     = useState(null);
  const [error, setError]   = useState('');

  const [form, setForm] = useState({
    first_name:'', last_name:'', email:'', phone:'', nic:'',
    date_of_birth:'', gender:'', address:'',
    emergency_contact_name:'', emergency_contact_phone:'',
    university:'', faculty:'', degree:'',
    internship_start:'', internship_end:'', project_title:'',
    letter_type:'Internship', signatory_name:'Mr. H. M. R. U. K. Bandara',
    signatory_title:'Chief Executive Officer (CEO)', requested_by:'',
  });
  const [responsibilities, setResponsibilities] = useState(['']);

  useEffect(() => {
    api.get('/responsibility-templates').catch(()=>{}).then(r => r && setTemplates(r.data?.data || []));
  }, []);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handlePreview = async () => {
    setPreviewing(true);
    try {
      const res = await api.post('/letters/preview', {
        employeeData: {
          first_name: form.first_name, last_name: form.last_name,
          gender: form.gender, university: form.university,
          faculty: form.faculty, internship_start: form.internship_start,
          internship_end: form.internship_end,
        },
        signatoryName: form.signatory_name || 'Mr. H. M. R. U. K. Bandara',
        signatoryTitle: form.signatory_title || 'Chief Executive Officer (CEO)',
        requestedBy: form.requested_by,
        startDate: form.internship_start || null,
        endDate: form.internship_end || null,
        university: form.university || null,
        faculty: form.faculty || null,
        timeType: form.time_type || null,
        letterStyle: form.letter_type === 'Internship' ? 'internship' : form.letter_type === 'Associate' ? 'associate' : 'permanent',
        responsibilities: responsibilities.filter(r => r.trim()),
      }, { responseType: 'blob' });
      const url = window.URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      window.open(url, '_blank');
    } catch { alert('Preview failed. Fill in your details first.'); }
    setPreviewing(false);
  };

  const handleSubmit = async () => {
    setSubmitting(true); setError('');
    try {
      const r = await api.post('/submissions/guest', {
        ...form,
        responsibilities: responsibilities.filter(r => r.trim()),
      });
      setDone(r.data);
    } catch(e) {
      setError(e.response?.data?.message || 'Submission failed. Please try again.');
      if (e.response?.data?.message?.includes('already registered')) setStep(0);
    }
    setSubmitting(false);
  };

  // ── Success screen ──
  if (done) return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#1a1f3c,#2d3a6b)',display:'flex',alignItems:'center',justifyContent:'center',padding:24}}>
      <div style={{background:'#fff',borderRadius:16,padding:40,maxWidth:480,width:'100%',textAlign:'center',boxShadow:'0 20px 60px rgba(0,0,0,.3)'}}>
        <div style={{fontSize:56,marginBottom:16}}>✅</div>
        <h2 style={{color:'var(--navy)',marginBottom:8}}>Submitted Successfully!</h2>
        <p style={{color:'var(--slate-500)',fontSize:14,marginBottom:20}}>Your request has been sent to admin for review. You'll be contacted once it's approved.</p>
        <div style={{background:'var(--indigo-pale)',borderRadius:10,padding:'12px 20px',marginBottom:24}}>
          <div style={{fontSize:12,color:'var(--slate-500)'}}>Your Reference ID</div>
          <div style={{fontSize:18,fontWeight:700,color:'var(--indigo)',marginTop:4}}>{done.employee_id}</div>
          <div style={{fontSize:11,color:'var(--slate-400)',marginTop:2}}>Save this for future reference</div>
        </div>
        <button className="btn btn-outline" onClick={() => nav('/login')} style={{width:'100%'}}>Back to Login</button>
      </div>
    </div>
  );

  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#1a1f3c,#2d3a6b)',padding:'32px 16px'}}>
      <div style={{maxWidth:620,margin:'0 auto'}}>

        {/* Header */}
        <div style={{textAlign:'center',marginBottom:28}}>
          <div style={{width:52,height:52,borderRadius:14,background:'#4f46e5',display:'inline-flex',alignItems:'center',justifyContent:'center',marginBottom:12}}>
            <svg width={26} height={26} fill="none" stroke="#fff" strokeWidth={1.8} viewBox="0 0 24 24"><path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/></svg>
          </div>
          <h1 style={{color:'#fff',fontSize:20,fontWeight:700,margin:0}}>Request a Letter</h1>
          <p style={{color:'rgba(255,255,255,.5)',fontSize:13,marginTop:4}}>Fill in your details — admin will review and generate your letter</p>
          <button onClick={()=>nav('/login')} style={{marginTop:8,background:'none',border:'none',color:'rgba(255,255,255,.5)',fontSize:12,cursor:'pointer',textDecoration:'underline'}}>Already have an account? Login →</button>
        </div>

        {/* Stepper */}
        <div style={{display:'flex',alignItems:'center',marginBottom:24}}>
          {STEPS.map((s,i) => (
            <React.Fragment key={s}>
              <div style={{display:'flex',alignItems:'center',gap:6,cursor:i<step?'pointer':'default'}} onClick={()=>i<step&&setStep(i)}>
                <div style={{width:28,height:28,borderRadius:'50%',background:step>=i?'#4f46e5':'rgba(255,255,255,.15)',color:'#fff',display:'flex',alignItems:'center',justifyContent:'center',fontSize:12,fontWeight:700,transition:'all .2s'}}>{step>i?'✓':i+1}</div>
                <span style={{fontSize:11,color:step===i?'#fff':'rgba(255,255,255,.4)',fontWeight:step===i?600:400,whiteSpace:'nowrap'}}>{s}</span>
              </div>
              {i<STEPS.length-1&&<div style={{flex:1,height:1,background:step>i?'#4f46e5':'rgba(255,255,255,.15)',margin:'0 8px',transition:'all .2s'}}/>}
            </React.Fragment>
          ))}
        </div>

        <div style={{background:'#fff',borderRadius:14,padding:28,boxShadow:'0 20px 60px rgba(0,0,0,.3)'}}>
          {error && <div className="alert alert-error" style={{marginBottom:16}}>{error}</div>}

          {/* STEP 0 — Personal */}
          {step===0 && (
            <>
              <h3 style={{color:'var(--navy)',fontSize:15,fontWeight:600,marginBottom:20}}>Personal Information</h3>
              <div className="form-grid">
                <div className="form-group"><label>First Name *</label><input value={form.first_name} onChange={e=>set('first_name',e.target.value)} placeholder="Kamal" /></div>
                <div className="form-group"><label>Last Name *</label><input value={form.last_name} onChange={e=>set('last_name',e.target.value)} placeholder="Perera" /></div>
                <div className="form-group"><label>NIC Number *</label><input value={form.nic} onChange={e=>set('nic',e.target.value)} placeholder="200012345678" /></div>
                <div className="form-group"><label>Email</label><input type="email" value={form.email} onChange={e=>set('email',e.target.value)} placeholder="kamal@email.com" /></div>
                <div className="form-group"><label>Phone</label><input value={form.phone} onChange={e=>set('phone',e.target.value)} placeholder="+94 77 123 4567" /></div>
                <div className="form-group"><label>Date of Birth</label><input type="date" value={form.date_of_birth} onChange={e=>set('date_of_birth',e.target.value)} /></div>
                <div className="form-group"><label>Gender</label>
                  <select value={form.gender} onChange={e=>set('gender',e.target.value)}>
                    <option value="">Select</option><option>Male</option><option>Female</option><option>Other</option>
                  </select>
                </div>
                <div className="form-group"><label>Emergency Contact</label><input value={form.emergency_contact_name} onChange={e=>set('emergency_contact_name',e.target.value)} placeholder="Name" /></div>
                <div className="form-group full"><label>Address</label><textarea value={form.address} onChange={e=>set('address',e.target.value)} placeholder="Your full address" /></div>
              </div>
            </>
          )}

          {/* STEP 1 — University */}
          {step===1 && (
            <>
              <h3 style={{color:'var(--navy)',fontSize:15,fontWeight:600,marginBottom:20}}>University & Internship Details</h3>
              <div className="form-grid">
                <div className="form-group full"><label>University / Institute *</label><input value={form.university} onChange={e=>set('university',e.target.value)} placeholder="University of Moratuwa" /></div>
                <div className="form-group"><label>Faculty</label><input value={form.faculty} onChange={e=>set('faculty',e.target.value)} placeholder="Faculty of Information Technology" /></div>
                <div className="form-group"><label>Degree / Programme</label><input value={form.degree} onChange={e=>set('degree',e.target.value)} placeholder="BSc (Hons) in IT" /></div>
                <div className="form-group"><label>Internship Start *</label><input type="date" value={form.internship_start} onChange={e=>set('internship_start',e.target.value)} /></div>
                <div className="form-group"><label>Internship End *</label><input type="date" value={form.internship_end} onChange={e=>set('internship_end',e.target.value)} /></div>
                <div className="form-group full"><label>Project Title</label><input value={form.project_title} onChange={e=>set('project_title',e.target.value)} placeholder="E.g. E-Commerce Platform Development" /></div>
                <div className="form-group"><label>Letter Type</label>
                  <select value={form.letter_type} onChange={e=>set('letter_type',e.target.value)}>
                    <option value="Internship">Internship Completion Letter</option>
                    <option value="Service">Service / Experience Letter</option>
                  </select>
                </div>
                <div className="form-group"><label>Requested By</label><input value={form.requested_by} onChange={e=>set('requested_by',e.target.value)} placeholder="e.g. University of Moratuwa" /></div>
                <div className="form-group"><label>Signatory Name</label><input value={form.signatory_name} onChange={e=>set('signatory_name',e.target.value)} /></div>
                <div className="form-group"><label>Signatory Title</label><input value={form.signatory_title} onChange={e=>set('signatory_title',e.target.value)} /></div>
              </div>
            </>
          )}

          {/* STEP 2 — Responsibilities */}
          {step===2 && (
            <>
              <h3 style={{color:'var(--navy)',fontSize:15,fontWeight:600,marginBottom:6}}>Duties & Responsibilities</h3>
              <p style={{fontSize:12,color:'var(--slate-500)',marginBottom:16}}>Select from templates or add your own. These appear in your letter.</p>
              <ResponsibilityPicker
                responsibilities={responsibilities}
                setResponsibilities={setResponsibilities}
                templates={templates}
                disabled={false}
              />
            </>
          )}

          {/* STEP 3 — Preview & Submit */}
          {step===3 && (
            <>
              <h3 style={{color:'var(--navy)',fontSize:15,fontWeight:600,marginBottom:16}}>Preview & Submit</h3>
              <div style={{background:'var(--indigo-pale)',borderRadius:10,padding:'14px 18px',marginBottom:16,display:'flex',alignItems:'center',gap:12}}>
                <span style={{fontSize:24}}>👁</span>
                <div style={{flex:1}}>
                  <div style={{fontSize:13,fontWeight:600,color:'var(--indigo)'}}>Preview Your Letter</div>
                  <div style={{fontSize:12,color:'var(--slate-500)'}}>See how your letter will look before submitting</div>
                </div>
                <button className="btn btn-primary btn-sm" onClick={handlePreview} disabled={previewing}>
                  {previewing ? 'Loading…' : 'Open Preview'}
                </button>
              </div>

              {/* Summary */}
              <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:8,marginBottom:16}}>
                {[['Name',`${form.first_name} ${form.last_name}`],['NIC',form.nic],['University',form.university],['Letter Type',form.letter_type],['Internship',`${form.internship_start} → ${form.internship_end}`],['Signatory',form.signatory_name]].map(([k,v])=>(
                  <div key={k} style={{background:'var(--slate-50)',borderRadius:8,padding:'9px 12px'}}>
                    <div style={{fontSize:11,fontWeight:600,color:'var(--slate-400)'}}>{k}</div>
                    <div style={{fontSize:13,color:'var(--navy)',marginTop:2}}>{v||'—'}</div>
                  </div>
                ))}
              </div>
              {responsibilities.filter(r=>r.trim()).length>0 && (
                <div style={{background:'var(--slate-50)',borderRadius:8,padding:'10px 14px',marginBottom:16}}>
                  <div style={{fontSize:12,fontWeight:600,color:'var(--slate-500)',marginBottom:6}}>Responsibilities</div>
                  {responsibilities.filter(r=>r.trim()).map((r,i)=><div key={i} style={{fontSize:13,color:'var(--navy)',marginBottom:3}}>{i+1}. {r}</div>)}
                </div>
              )}
              <div style={{background:'#fef3c7',borderRadius:8,padding:'10px 14px',fontSize:12,color:'#92400e'}}>
                ⚡ After submission, admin will review and generate your official letter. You'll be notified via email.
              </div>
            </>
          )}

          {/* Navigation */}
          <div style={{display:'flex',justifyContent:'space-between',marginTop:24,gap:10}}>
            <div>
              {step>0 && <button className="btn btn-outline" onClick={()=>setStep(s=>s-1)}>← Back</button>}
              <button className="btn btn-outline" style={{marginLeft:step>0?8:0}} onClick={()=>nav('/login')}>Cancel</button>
            </div>
            <div>
              {step<STEPS.length-1 && (
                <button className="btn btn-primary" onClick={()=>setStep(s=>s+1)}
                  disabled={step===0&&(!form.first_name||!form.nic)}>
                  Next →
                </button>
              )}
              {step===STEPS.length-1 && (
                <button className="btn btn-success" onClick={handleSubmit} disabled={submitting}>
                  {submitting ? 'Submitting…' : '📤 Submit Request'}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
